import keyMirror from 'keymirror';

export default keyMirror({
  LOGIN: null,
  LOGOUT: null,
  RECOVERY: null,
  UPDATE_DOCUMENTS: null,
  DECREMENT_DOCUMENTS_COUNT: null,
});
